import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { TiplymeLogo } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Invalid or missing reset link.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm animate-fade-up">
        <TiplymeLogo />
        <h1 className="mt-8 font-heading text-2xl font-bold">Set a new password</h1>
        <p className="mt-1 text-sm text-muted-foreground">Choose a strong password you'll remember.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="password">New password</Label>
            <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" className="mt-1.5" placeholder="At least 6 characters" />
          </div>
          <Button type="submit" disabled={busy} data-testid="reset-submit-button" className="w-full rounded-full bg-brand-green font-semibold text-white hover:bg-brand-green/90">
            {busy ? "Updating…" : "Update password"}
          </Button>
        </form>
        <Link to="/login" className="mt-6 block text-center text-sm font-semibold text-brand-green hover:underline" data-testid="back-to-login-link">Back to sign in</Link>
      </div>
    </div>
  );
}
